<template>
    <div>
        <FileUploadButton
            title="upload"
            accept=".pdf"
            mode="private"
            :deletable="false"
            @submit="onUpload"
        />
        <div
            v-if="modelValue.upload_key"
            class="mt-4"
        >
            <TextField
                v-model="modelValue.name"
                name="contract_template_name"
                label="name"
                help="help_contract_template_name"
                :required="true"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import FileUploadButton from '@partials/actions/FileUploadButton.vue'
import { TextField } from '@src/components'
import { ContractTemplate } from '@src/types'
import { UploadFileResponse } from '@src/utils/api/s3'
import { toRefs, watch } from 'vue'

// FIXED: Expect the raw object, not the Ref wrapper
const props = defineProps<{
    modelValue: Partial<ContractTemplate>
}>()

const { modelValue } = toRefs(props)
const emit = defineEmits(['update:modelValue'])

function onUpload(response: UploadFileResponse, fileName: string) {
    modelValue.value.url = response.temp_storage_url
    modelValue.value.name = fileName
    modelValue.value.upload_key = response.key
}

watch(
    modelValue,
    (value) => {
        emit('update:modelValue', value)
    },
    { deep: true }
)
</script>
